import React from "react";

const Stars = () => {
  return null;
};

export default Stars;
